import { environment } from '@fantaz/shared/app-config';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

export const extModules = [
  StoreDevtoolsModule.instrument({
    maxAge: 25,
    name: `FantaZ ${environment.name}`,
    connectInZone: true,
  }),
];
